import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { history } from "./history";

ReactDOM.render(
  <Provider store={store}>
    <HistoryRouter history={history as any}>
      <App />
    </HistoryRouter>
  </Provider>,
  document.getElementById("root")
);

serviceWorkerRegistration.unregister();

reportWebVitals();
